var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAddItem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42 42",
    style: {
      enableBackground: "new 0 0 42 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#413892;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_5840",
    transform: "translate(1893 -3465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4454",
    transform: "translate(147 207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4452",
    transform: "translate(-3 -326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4048",
    transform: "translate(23 362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_2518"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-2039,3263.5c-2.8,0-5.5-0.5-8-1.6c-2.4-1-4.6-2.5-6.5-4.4s-3.4-4.1-4.4-6.5c-1.1-2.5-1.6-5.2-1.6-8 s0.5-5.5,1.6-8c1-2.4,2.5-4.6,4.4-6.5s4.1-3.4,6.5-4.4c2.5-1.1,5.2-1.6,8-1.6s5.5,0.5,8,1.6c2.4,1,4.6,2.5,6.5,4.4 c1.9,1.9,3.4,4.1,4.4,6.5c1.1,2.5,1.6,5.2,1.6,8s-0.5,5.5-1.6,8c-1,2.4-2.5,4.6-4.4,6.5c-1.9,1.9-4.1,3.4-6.5,4.4 C-2033.5,3263-2036.2,3263.5-2039,3263.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-2039,3223c-2.7,0-5.3,0.5-7.8,1.6c-2.4,1-4.5,2.4-6.4,4.3s-3.3,4-4.3,6.4c-1,2.5-1.6,5.1-1.6,7.8 s0.5,5.3,1.6,7.8c1,2.4,2.4,4.5,4.3,6.4s4,3.3,6.4,4.3c2.5,1,5.1,1.6,7.8,1.6s5.3-0.5,7.8-1.6c2.4-1,4.5-2.4,6.4-4.3 c1.8-1.8,3.3-4,4.3-6.4c1-2.5,1.6-5.1,1.6-7.8s-0.5-5.3-1.6-7.8c-1-2.4-2.4-4.5-4.3-6.4c-1.8-1.8-4-3.3-6.4-4.3 C-2033.7,3223.5-2036.3,3223-2039,3223 M-2039,3222c11.6,0,21,9.4,21,21s-9.4,21-21,21c-11.6,0-21-9.4-21-21 S-2050.6,3222-2039,3222z"
  })))))), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "29,20.5 21.5,20.5 21.5,13 20.5,13 20.5,20.5 13,20.5 13,21.5 20.5,21.5 20.5,29 21.5,29 21.5,21.5  29,21.5  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddItem);
export default __webpack_public_path__ + "static/media/icon_add_item.84e3d71eb4c657816203564d220f4bcd.svg";
export { ForwardRef as ReactComponent };